/* function loadScript(url, callback) {
    var head = document.head;
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = false
    script.src = url;

    script.onreadystatechange = callback;
    script.onload = callback;

    head.appendChild(script);
} */

// Polyfill
if (!String.prototype.endsWith) {
  String.prototype.endsWith = function(search, this_len) {
    if (this_len === undefined || this_len > this.length) {
      this_len = this.length;
    }
    return this.substring(this_len - search.length, this_len) === search;
  };
}

var Tracker = function() {
    this.exec = function() {
        ;(function(p,l,o,w,i,n,g){if(!p[i]){p.GlobalSnowplowNamespace=p.GlobalSnowplowNamespace||[]; p.GlobalSnowplowNamespace.push(i);p[i]=function(){(p[i].q=p[i].q||[]).push(arguments) };p[i].q=p[i].q||[];n=l.createElement(o);g=l.getElementsByTagName(o)[0];n.async=1; n.src=w;g.parentNode.insertBefore(n,g)}}(window,document,"script","//storage.googleapis.com/pai-analytics-config/sjhd38sk.gc.js","snowplow"));

        snowplow("newTracker", "sp", "collector-hub.dhatma.com", {
          appId: "sjwsfq",
          platform: "web",
          cookieSecure: true,
          encodeBase64: true,
          eventMethod: 'beacon',
          stateStorageStrategy: "cookieAndLocalStorage",
          contexts: {
            webPage: true,
            performanceTiming: true
          }
        });

        snowplowPageViewId = null;
        snowplowReferrer = null
        snowplow(function () {
          snowplowPageViewId = this.sp.getPageViewId();
          snowplowReferrer = document.referrer
        });

        snowplow('trackPageView');

        // Listing impressions
        var visCounters = {} // Indexed by DOM element
        var visCountersSearchQuery = {} // Indexed by DOM element; Value - the current search query
        var visTotals = [] // Indexed by and array - product_key, search query
        var productIds = {} // Key - product handle, value - product ID (int)
        var currentSearchField = null
        var currentSearchFieldListener = false
        var currentSearchQuery = null

        var PRODUCT_URI_REGEX = /products\/([A-Za-z0-9\-]+)$/

        function detectSearchField() {
        	var bestGuess = null
        	var bestScore = 0

            var elems = document.querySelectorAll("input[type='text'], input[type='search']").forEach(e => {
            	// Compute a score - likelihood of being the "search" input
            	var score = 0

				for (var att, i = 0, atts = e.attributes, n = atts.length; i < n; i++) {
					att = atts[i];
					var attrName = att.nodeName
					var attrValue = att.nodeValue

					if (attrName === "name" && attrValue === "q")
						score += 1000

					if (attrValue.includes("search"))
						score += 5
				}

				if (score > bestScore) {
					bestScore = score
					bestGuess = e
				}
            })

			return bestScore > 0 ? bestGuess : null
        }

        function getElementMap() {
            var uriPathPattern = PRODUCT_URI_REGEX

            var elemMap = {}

            var elems = document.querySelectorAll("a").forEach(e => {
                var href = e.getAttribute("href")
                if (href) {
                    var res = href.split(/[?#]/)[0].match(uriPathPattern)
                    if (res && res.length > 1 && res[1]) {
                        var elemKey = res[1]

                        if (elemKey in elemMap) {
                            elemMap[elemKey].push(e)
                        } else {
                            elemMap[elemKey] = [e]
                        }

                        // Lazy fetch product info
                        if (!(elemKey in productIds)) {
                            productIds[elemKey] = null
                            fetch("/products/" + elemKey + ".json")
                                .then(res => {
                                    if (res.ok) {
                                        return res.json();
                                    } else {
                                        throw new Error(res.statusText);
                                    }
                                })
                                .then(data => {
                                    productIds[elemKey] = data.product.id
                                })
                                .catch(error => {
                                    // console.log(error)
                                    // return Promise.reject()
                                    // Suppress errors
                                })
                        }
                    }
                }
            })

            return elemMap;
        }

        function isHidden(el) {
        	return (el.offsetParent === null)
		}

        function isElementVisible(element, partial) {
        	if (isHidden(element))
        		return false;

        	if (!partial) {
        		var elementBoundingBox = element.getBoundingClientRect();
		        var elementTopY = elementBoundingBox.top;
		        var elementBottomY = elementBoundingBox.top + elementBoundingBox.height;
		        return elementTopY >= 0 && elementBottomY <= Math.min(document.documentElement.clientHeight, window.innerHeight || 0);
        	} else {
        		var elementBoundingBox = element.getBoundingClientRect();
		        var elementTopY = elementBoundingBox.top;
		        var elementBottomY = elementBoundingBox.top + elementBoundingBox.height;
		        var viewportBottom = Math.min(document.documentElement.clientHeight, window.innerHeight || 0);
		        var intersectTop = Math.max(elementTopY, 0)
		        var intersectBottom = Math.min(elementBottomY, viewportBottom)
		        var intersectHeight = parseFloat(intersectBottom - intersectTop)
		        var elementHeight = parseFloat(elementBottomY - elementTopY)
		        return intersectHeight / elementHeight >= 0.5;
        	}
        }

        // Search field keydown handler
        function listenSearchQuery(e) {
        	if (e.isComposing || e.keyCode === 229) {
        		return;
        	}

        	currentSearchQuery = e.target.value
        	updateVisCounters(e, false, true)
        }
        // var listenSearchQueryDebounce = debounce(listenSearchQuery, 250)
        var listenSearchQueryDebounce = listenSearchQuery

        function updateVisCountersMutation(mutRecord, mutObserver, lastFrame) {
            updateVisCounters(mutRecord, lastFrame)
        }

        function updateVisCounters(event, lastFrame, fromSearchField) {
        	if (!fromSearchField) {
		    	// Check the search field - start listening for key presses
		        // Remove & add the new one
		        if (currentSearchField) {
		        	window.removeEventListener("keydown", listenSearchQueryDebounce)
		        	currentSearchQuery = null
		        }
		        currentSearchField = detectSearchField()
		        if (currentSearchField && isElementVisible(currentSearchField, false)) {
		        	window.addEventListener("keydown", listenSearchQueryDebounce)
		        	currentSearchQuery = currentSearchField.value
		        }
        	}

            // Create / update the visibility counters

            var elemMap = getElementMap()
            var cts = Date.now()

            Object.entries(elemMap).forEach(e => {
                var elemKey = e[0]
                var elems = e[1]

                elems.forEach(el => {
                	// Update the counters
                    if (isElementVisible(el, true) && !lastFrame) {
                        if (!(el in visCounters)) {
                            visCounters[el] = cts
                            visCountersSearchQuery[el] = (currentSearchQuery === null ? "" : currentSearchQuery)
                        }
                    } else {
                        if (el in visCounters) {
                            var ets = visCounters[el]
                            var eSearchQuery = visCountersSearchQuery[el]
                            delete visCounters[el]
                            delete visCountersSearchQuery[el]

                            // Only capture the last "search query"
                            if (!(!lastFrame && eSearchQuery && currentSearchQuery !== null)) {
		                        // Update the elemKey - add the current search query
					 			var updatedElemKey = elemKey + "|" + eSearchQuery // XXX Suboptimal

		                        if (elemKey in visTotals) {
		                            visTotals[updatedElemKey] += (cts - ets)
		                        } else {
		                            visTotals[updatedElemKey] = (cts - ets)
		                        }
                            }
                        }
                    }
                })
            })
        }
        window._updateVisCounters = updateVisCounters

        function buildEventData() {
            if (Object.keys(visTotals).length === 0 && visTotals.constructor === Object)
                return null;

            var res = {
                type: "listing_view",
                page_path: window.location.pathname,
                elem_keys: [],
                vis_counters: [],
                elem_ids: [],
                search_keywords: []
            }

            var idx = 0
            Object.entries(visTotals).forEach(arr => {
            	var arr0 = arr[0].split("|")
            	var handle = arr0[0]
            	var searchQuery = arr0[1]

                res.elem_keys.push(handle)
                res.vis_counters.push(arr[1])

                var productId = null;
                if (handle in productIds)
                    productId = productIds[handle]
                res.elem_ids.push(productId)

                res.search_keywords.push(searchQuery ? searchQuery : null)

                idx++
            })

            return res
        }
        window._buildEventData = buildEventData

        document.addEventListener("ready", function(e) { updateVisCounters(e, false) })
        window.addEventListener("scroll", debounce(updateVisCounters, 250))

        // Also update vis counters on DOM change - use Mutation Observer
        domReady(function() {
        	const targetNode = document.getElementsByTagName("body")[0];
        	const config = { attributes: true, childList: true, subtree: true };

        	const domChangeCallback = debounce(updateVisCountersMutation, 250);

        	const observer = new MutationObserver(domChangeCallback);
        	observer.observe(targetNode, config);
        })

        // Send the "impressions" event
        window.addEventListener('unload', function() {
            updateVisCounters(null, true)
            var eventData = buildEventData()

            if (eventData) {
              snowplow('trackSelfDescribingEvent', {
                  schema: 'iglu:com.pai/impressions_event/jsonschema/1-0-0',
                  data: eventData
              });
            }
        });

        // Add to cart monitoring - form submission & AJAX requests
        var addToCartEventsDisabled = false

        document.addEventListener("mouseup", function(e) {
            addToCartEventsDisabled = false // Reset on user interaction
        });
        document.addEventListener("keyup", function(e) {
            addToCartEventsDisabled = false // Reset on user interaction
        });

        // Add to cart AJAX request monitoring
        (function(send) {
            XMLHttpRequest.prototype.send = function() {
                this.addEventListener("load", function() {
                    // if (this.readyState === 4) { // Should always be 4
                        // Add to cart
                        if (this._url && this._url.indexOf("/cart/add.js") > -1 && this._method === "POST") {
                            var addToCartResp = null
                            try {
                                addToCartResp = JSON.parse(this.response)
                            } catch (e) {
                                return ;
                            }

                            if (addToCartEventsDisabled)
                                return ;

                            processAddToCart(addToCartResp)
                        }
                    // }
                }, false);

                send.apply(this, arguments);
            };

        })(XMLHttpRequest.prototype.send);

        function processAddToCart(addToCartResp) {
            // Fetch the cart
            fetch("/cart.js")
                .then(res => {
                    if (res.ok) {
                        return res.json();
                    } else {
                        throw new Error(res.statusText);
                    }
                })
                .then(function(data) {
                    var items = []
                    if (addToCartResp.hasOwnProperty("items") && Array.isArray(addToCartResp.items)) {
                        items = addToCartResp.items
                    } else {
                        items.push(addToCartResp)
                    }

                    items.forEach(function(item) {
                        // Build self-desc event data
                        var eventPayload = {
                            type: "add_to_cart",
                            cart_id: data.token
                        }

                        var ctx = {
                            product_id: item.product_id,
                            product_handle: item.handle,
                            variant_id: item.variant_id,
                            variant_price: item.price + "",
                            variant_original_price: item.original_price + "",
                            variant_discounted_price: item.discounted_price + "",
                            product_title: item.product_title,
                            variant_title: item.variant_title
                        }

                        // Disable "add to cart" events for a small interval
                        // or until a new user interaction (done by the mouseup
                        // & keypress event listener)
                        addToCartEventsDisabled = true
                        setTimeout(function() {
                            addToCartEventsDisabled = false
                        }, 1500)
                        // Use the original referrer when sending the "add_to_cart" event
                        // (To avoid the issue caused by changing the page url
                        // when switching product variants)
                        snowplow('setReferrerUrl', snowplowReferrer);

                        snowplow('trackSelfDescribingEvent', {
                            schema: 'iglu:com.pai/ecom_event/jsonschema/1-0-0',
                            data: eventPayload
                        },[{
                            schema: 'iglu:com.pai/product_info/jsonschema/1-0-0',
                            data: ctx
                        }]);
                        // Store the details so we can send these details on the "checkout thank-you" page
                        try {
                            storeAddToCartEvents(data.token, ctx)
                        } catch (e) {
                            console.error(e)
                        }
                    })
                })
                .catch(error => {
                    // console.log(error)
                    // return Promise.reject()
                    // Suppress errors
                })
        }

        // Add to cart from form (usually used in listings)
        function getCookie(cname) {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            for(var i = 0; i <ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                  c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                  return c.substring(name.length, c.length);
                }
            }
            return "";
        }

        var addToCartFormEvtHandler = function(e) {
            if (addToCartEventsDisabled)
                return ;

            try {
                var elem = e.target

//                    var formTypeElem = elem.querySelector("[name=form_type]")
//                    var formType = null
//                    if (formTypeElem) {
//                        formType = formTypeElem.value
//                    }

                var quantityElem = elem.querySelector("[name=quantity]")
                var quantity = 1
                if (quantityElem) {
                    quantity = quantityElem.value
                }

                var idElem = elem.querySelector("[name=id]")
                var id = null
                if (idElem) {
                    id = idElem.value
                }

                if (/*!formType || formType != "product" || */!quantity || !id)
                    return ;

                // Send the event
                // Build self-desc event data
                var cartId = getCookie("cart")
                if (!cartId)
                    return ;

                var eventPayload = {
                    type: "add_to_cart",
                    cart_id: cartId
                }

                var ctx = {
                    product_id: null,
                    product_handle: null,
                    variant_id: parseInt(id),
                    variant_price: null,
                    variant_original_price: null,
                    variant_discounted_price: null,
                    product_title: null,
                    variant_title: null
                }

                // Disable "add to cart" events for a small interval
                // or until a new user interaction (done by the mouseup
                // & keypress event listener)
                addToCartEventsDisabled = true
                setTimeout(function() {
                    addToCartEventsDisabled = false
                }, 1500)

                // Use the original referrer when sending the "add_to_cart" event
                // (To avoid the issue caused by changing the page url
                // when switching product variants)
                snowplow('setReferrerUrl', snowplowReferrer);
                snowplow('trackSelfDescribingEvent', {
                    schema: 'iglu:com.pai/ecom_event/jsonschema/1-0-0',
                    data: eventPayload
                },[{
                    schema: 'iglu:com.pai/product_info/jsonschema/1-0-0',
                    data: ctx
                }]);
                // Store the details so we can send these details on the "checkout thank-you" page
                try {
                    storeAddToCartEvents(cartId, ctx)
                } catch (e) {
                    console.error(e)
                }
            } catch (e) {
                // console.log(e)
                // Suppress errors
            }
        }

        function installAddToCartFormListeners() {
            Array.from(document.querySelectorAll("form"))
                .filter(e => e.getAttribute("method") && e.getAttribute("action") && e.getAttribute("method").toUpperCase() == "post".toUpperCase() && e.getAttribute("action").endsWith("/cart/add"))
                .forEach(e => {
                	e.removeEventListener("submit", addToCartFormEvtHandler)
                	e.addEventListener("submit", addToCartFormEvtHandler, false)
                })
        }

        domReady(function() {
            installAddToCartFormListeners()

            // Re-install the add to cart trackers after each DOM change
            const targetNode = document.getElementsByTagName("body")[0];
            const config = { attributes: true, childList: true, subtree: true };

            const domChangeCallback = debounce(installAddToCartFormListeners, 250);

            const observer = new MutationObserver(domChangeCallback);
            observer.observe(targetNode, config);
        })

        // Additional processing of "add_to_cart" events - enhance and store them (we will
        // send them after the user finishes the checkout)
        function storeAddToCartEvents(cartToken, ctx) {
            // Check what we already is stored
            var storedCartToken = localStorage.getItem("dhatma_ecom_cart_token")
            var storedCartContents = localStorage.getItem("dhatma_ecom_cart_contents")

            if ((storedCartToken !== cartToken) || !storedCartContents) {
                storedCartContents = []
            } else {
                storedCartContents = JSON.parse(storedCartContents)
            }

            storedCartToken = cartToken

            // De-duplicaation based on variant_id (we only keep the first event)
            if (ctx["variant_id"]) {
                for (var i = 0; i < storedCartContents.length; i++) {
                    var e = storedCartContents[i]
                    if (e["variant_id"] && e["variant_id"].toString() === ctx["variant_id"].toString())
                        return ;
                }
            }

            // Add the required / additional values
            ctx["page_url"] = window.location.href
            ctx["refr_url"] = snowplowReferrer

            var spCookie = findCookieByName("_sp_id")
            if (spCookie) {
                var n = spCookie.lastIndexOf('.')
                if (n >= 0)
                    ctx["domain_sessionid"] = spCookie.substring(n + 1)
            }

            ctx["event_id"] = snowplowPageViewId

            storedCartContents.push(ctx)

            // Store the updated values
            localStorage.setItem("dhatma_ecom_cart_token", storedCartToken)
            localStorage.setItem("dhatma_ecom_cart_contents", JSON.stringify(storedCartContents))
        }

        // Send the "add to cart" details - when the user is on the "checkout thank-you" page
        domReady(function() {
            if (window.location.href) {
                try {
                    var pageUrl = new URL(window.location.href)
                    var pagePath = pageUrl.pathname
                    if (pagePath.endsWith("thank_you") || pagePath.endsWith("thank_you/")) {
                        var storedCartToken = localStorage.getItem("dhatma_ecom_cart_token")
                        var storedCartContents = localStorage.getItem("dhatma_ecom_cart_contents")

                        if (storedCartToken && storedCartContents) {
                            // Send the sp event
                            var eventPayload = {
                                type: "cart_checkout",
                                cart_id: storedCartToken,
                                products_to_cart: storedCartContents
                            }

                            snowplow('trackSelfDescribingEvent', {
                                schema: 'iglu:com.pai/ecom_event/jsonschema/1-0-0',
                                data: eventPayload
                            });
                        }
                    }
                } catch (e) {
                    console.error(e)
                }
            }        
        })

        // Fetch API interceptor - process "add to cart" & "buy now" events
        function processBuyNowCall(response, requestArgs) {
            var gotoCheckoutResp = response

            // The origin must be a product page
            var requestBody = JSON.parse(requestArgs[1].body)
            if (requestBody["checkout"]["page_type"] !== "product") {
                return ;
            }

            // Retrieve the checkout ID
//            var headerLoc = response.headers["Location"]
//            if (!headerLoc) {
//                return ;
//            }

//            var checkoutToken = null;
//            var matchRes = headerLoc.match(/\/checkouts\/([a-zA-Z0-9]+)\.json$/)
//            if (matchRes && matchRes.length === 2) {
//                checkoutToken = matchRes[1]
//            }

            var checkoutToken = response["checkout"]["token"]

            // Send the event
            if (checkoutToken) {
                var eventPayload = {
                    type: "buy_now",
                    cart_id: checkoutToken
                }

                var checkout = gotoCheckoutResp["checkout"]
                var ctx = {
                    product_id: checkout["line_items"][0]["product_id"],
                    product_handle: null,
                    variant_id: checkout["line_items"][0]["variant_id"],
                    variant_price: checkout["line_items"][0]["price"],
                    variant_original_price: null,
                    variant_discounted_price: null,
                    product_title: checkout["line_items"][0]["title"],
                    variant_title: checkout["line_items"][0]["variant_title"]
                }

                snowplow('trackSelfDescribingEvent', {
                    schema: 'iglu:com.pai/ecom_event/jsonschema/1-0-0',
                    data: eventPayload
                },[{
                    schema: 'iglu:com.pai/product_info/jsonschema/1-0-0',
                    data: ctx
                }]);
            }
        }

        var constantMock = window.fetch;
        window.fetch = function() {
            // console.log(arguments);

            return new Promise((resolve, reject) => {
                constantMock.apply(this, arguments)
                    .then((response) => {
                        if (response.url.indexOf("/wallets/checkouts.json") > -1 && response.type != "cors") {
                            // "Buy it now"
                            // console.log("Buy it now intercept")

                            try {
                                response.clone().json()
                                    .then(data => {
                                        try {
                                            processBuyNowCall(data, arguments)
                                        } finally {
                                            resolve(response)
                                        }
                                    })
                            } catch (e) {
                                resolve(response);
                            }
                        } else
                        if (response.url.indexOf("/cart/add.js") > -1 && response.type != "cors") {
                            // "Add to cart" - using the fetch API

                            try {
                                response.clone().json()
                                    .then(data => {
                                        try {
                                            processAddToCart(data)
                                        } finally {
                                            resolve(response)
                                        }
                                    })
                            } catch (e) {
                                resolve(response);
                            }
                        } else {
                            resolve(response);
                        }
                    })
                    .catch((error) => {
                        reject(error);
                    })
            });
        }

        // Product view handling
        var isProductPage = window.location.pathname.split(/[?#]/)[0].match(PRODUCT_URI_REGEX)
        if (isProductPage) {
            var productHandle = isProductPage[1]

            fetch("/products/" + productHandle + ".json")
                .then(res => {
                    if (res.ok) {
                        return res.json();
                    } else {
                        throw new Error(res.statusText);
                    }
                })
                .then(data => {
                    var productInfo = data.product

                    var eventPayload = {
                        type: "product_view",
                        page_path: window.location.pathname,
                        elem_keys: [productInfo.handle],
                        vis_counters: [0],
                        elem_ids: [productInfo.id]
                    }

                    var ctx = {
                        product_id: productInfo.id,
                        product_handle: productInfo.handle,
                        variant_id: null,
                        variant_price: productInfo.variants[0].price,
                        variant_original_price: null,
                        variant_discounted_price: null,
                        product_title: productInfo.title,
                        variant_title: null
                    }

                    snowplow('trackSelfDescribingEvent', {
                        schema: 'iglu:com.pai/impressions_event/jsonschema/1-0-0',
                        data: eventPayload
                    },[{
                        schema: 'iglu:com.pai/product_info/jsonschema/1-0-0',
                        data: ctx
                    }]);
                })
                .catch(error => {
                    // console.log(error)
                    // return Promise.reject()
                    // Suppress errors
                })
        }
    };

    // Utilities
    function debounce(func) {
      var wait = arguments.length <= 1 || arguments[1] === undefined ? 100 : arguments[1];

      var timeout = void 0;
      return function () {
        var _this = this;

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        clearTimeout(timeout);
        timeout = setTimeout(function () {
          func.apply(_this, args);
        }, wait);
      };
    }

    function domReady(fn) {
      document.addEventListener("DOMContentLoaded", fn);
      if (document.readyState === "interactive" || document.readyState === "complete" ) {
        fn();
      }
    }

    function decodeCookie() {
      var cookieParts = document.cookie.split(";"),
      cookies = {};

      for (var i = 0; i < cookieParts.length; i++) {
        var name_value = cookieParts[i],
            equals_pos = name_value.indexOf("="),
            name       = unescape( name_value.slice(0, equals_pos) ).trim(),
            value      = unescape( name_value.slice(equals_pos + 1) );

        cookies[":" + name] = value;
      }
      return cookies;
    }

    function findCookieByName(prefix) {
      var cookies = decodeCookie();

      for (name in cookies) {
        var value = cookies[name];
        if (name.indexOf(prefix) === 0) {
          return value;
        }
      }
    }

    return this;
}

// loadScript(LOD_URL, function() {
    // loadScript(JQ_URL, function() {
        new Tracker().exec()
    // })
// })